import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueueStatsContentsEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const queueStatsContents: CaseReducer<NinchatState> = (state, action) => {
    const {queue_id} = action.meta.arg

    const {
        queue_stats,
        ...rest
    } = extractProperties<NinchatQueueStatsContentsEvent>(action.payload)

    isEmpty(rest)

    state._user_queues_stats[queue_id] = queue_stats
}
